import script from "./NewProjectFundraisingGoalsView.vue?vue&type=script&setup=true&lang=js"
export * from "./NewProjectFundraisingGoalsView.vue?vue&type=script&setup=true&lang=js"

import "./NewProjectFundraisingGoalsView.vue?vue&type=style&index=0&id=c5637712&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-c5637712"]])

export default __exports__